<template>
	<Modal
		:title="$t('general.error')"
		type="danger"
		:confirmText="$t('crud.ok')"
		@close="$emit('close')"
		@confirm="$emit('close')"
	>
		<div class="text-center">
			<div class="mb-3">
				<Icon
					:icon="['fas', 'exclamation-triangle']"
					size="3x"
					class="text-warning"
				/>
			</div>

			<div class="mb-3">
				<h5 class="mb-2">
					{{ errorTitle || $t('general.unable-to-apply') }}
				</h5>
				<p class="text-muted">
					{{ errorMessage }}
				</p>
			</div>

			<!-- Show link to personality test if this is a personality validation error -->
			<div v-if="isPersonalityError" class="mt-3">
				<router-link
					:to="
						`/assessment/applicant/${$applicantProfile.id}/consent`
					"
					class="btn btn-primary btn-sm"
					@click="$emit('close')"
				>
					{{ $t('general.take-personality-test') }}
				</router-link>
			</div>
		</div>
	</Modal>
</template>

<script>
import Modal from '~/components/ui/layout/Modal'
import Icon from '~/components/ui/common/Icon'

export default {
	components: {
		Modal,
		Icon
	},
	props: {
		error: {
			type: [Object, String],
			default: null
		},
		errorTitle: {
			type: String,
			default: null
		},
		errorMessage: {
			type: String,
			required: true
		}
	},
	computed: {
		isPersonalityError() {
			// Check if this is the personality test validation error
			return (
				this.errorMessage &&
				(this.errorMessage.includes('personality test') ||
					this.errorMessage.includes('Persönlichkeitstest') ||
					this.errorMessage ===
						this.$t('validation.take-personality-test-first'))
			)
		}
	}
}
</script>
